import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from "react-i18next";

interface Props {
  onOpenApplication: () => void;
}

const InitiatedByUniNotification: React.FC<Props> = ({ onOpenApplication }) => {
    const { t } = useTranslation('common');
    return <Alert status="info" flexDirection="column" mb="4">
    <Box display="flex" mb={2}>
      <AlertIcon />
      <Box flex="1">
        <AlertTitle>{t('common:applicationHasNotBeenSubmitted')}</AlertTitle>
        <AlertDescription>
          {t('common:thisApplicationWasCreatedByTheUn')}
                            </AlertDescription>
      </Box>
    </Box>

    <Button size="md" variant="solid" onClick={onOpenApplication} ml={8}>
      {t('common:openApplication')}
                </Button>
  </Alert>;
  };

export default InitiatedByUniNotification;
